import React, { Component } from "react";
import MapElement from "./MapElement.js";

import { Link } from "react-scroll";
import { Link as RouteLink } from "react-router-dom";

import bio from "./images/bio.jpg";
import media from "./images/media.jpg";
import book from "./images/environmental-book.JPG";
import cv from "./images/cv.jpg";

class Map extends Component {
  render() {
    return (
      <React.Fragment>
        <div style={mapStyle}>
          <Link to="bio" spy={true} smooth={true} offset={-80} duration={500}>
            <MapElement img={bio} alt="About" id="bioBox" />
          </Link>

          <RouteLink to="/cv">
            <MapElement img={cv} alt="CV" id="cvBox" />
          </RouteLink>

          <Link to="book" spy={true} smooth={true} offset={-80} duration={500}>
            <MapElement img={book} alt="Books" id="bookBox" />
          </Link>

          <Link to="media" spy={true} smooth={true} offset={-80} duration={500}>
            <MapElement img={media} alt="Media" id="mediaBox" />
          </Link>
        </div>
      </React.Fragment>
    );
  }
}

const mapStyle = {
  maxWidth: "1400px",
  background: "#white",
  color: "#000",
  margin: "auto",
  padding: "80px 100px 40px 100px",

  display: "flex",
  justifyContent: "center",
  gap: "2rem",
  flexWrap: "wrap",
  overflow: "auto",
};

export default Map;
